import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

const WhatsappOutlined = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: BusinessIconImageProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'path',
        {
          d: 'M12 3.50003C13.4029 3.4526 14.7961 3.7411 16.0552 4.33974C17.3144 4.93839 18.4002 5.82856 19.2158 6.93074C20.0314 8.03292 20.5513 9.31281 20.7292 10.6561C20.907 11.9994 20.7372 13.3643 20.235 14.6288C19.7328 15.8934 18.9137 17.0183 17.851 17.903C16.7882 18.7877 15.5149 19.4048 14.1447 19.6991C12.7745 19.9933 11.3501 19.9556 9.99865 19.5894C8.64723 19.2231 7.41087 18.5396 6.4 17.6L3.5 18.6L4.7 15.3C4.07784 14.0744 3.78262 12.7183 3.8411 11.3547C3.89957 9.99117 4.30991 8.66325 5.03489 7.49136C5.75987 6.31947 6.77658 5.34068 7.99283 4.6437C9.20909 3.94673 10.5864 3.55362 12 3.50003Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.5",
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M15.4054 13.4859C15.2211 13.3912 14.303 12.9415 14.1323 12.8806C13.9615 12.8164 13.8364 12.7859 13.713 12.9753C13.5879 13.163 13.2328 13.5806 13.1212 13.7074C13.013 13.8325 12.9031 13.8477 12.7188 13.7547C11.6233 13.2069 10.9047 12.7775 10.1828 11.5382C9.99175 11.2085 10.3738 11.2322 10.7306 10.5204C10.7915 10.3953 10.761 10.2888 10.7137 10.1941C10.6663 10.0994 10.2944 9.18304 10.1388 8.8094C9.98837 8.4459 9.83283 8.49662 9.71955 8.48986C9.61134 8.48309 9.48792 8.48309 9.36281 8.48309C9.2377 8.48309 9.03651 8.53043 8.86574 8.71472C8.69498 8.90239 8.21313 9.3538 8.21313 10.2702C8.21313 11.1865 8.88096 12.0741 8.97226 12.1993C9.06694 12.3244 10.2859 14.2044 12.1575 15.0143C13.341 15.5249 13.8043 15.5688 14.396 15.4809C14.7561 15.4268 15.4984 15.0312 15.6522 14.5933C15.8061 14.1571 15.8061 13.7834 15.7604 13.7057C15.7148 13.6228 15.5897 13.5755 15.4054 13.4859Z',
          fill: 'currentColor',
        },
      ),
    ],
  );

export default WhatsappOutlined;
